import { render, staticRenderFns } from "./price_edit.vue?vue&type=template&id=73d5801c&"
import script from "./price_edit.vue?vue&type=script&lang=ts&"
export * from "./price_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports